
import { lazy } from 'react';

const ServiceManagement = lazy(() => import('@/pages/ServiceManagement'));

export const serviceRoutes = [
  {
    path: '/app/services',
    element: ServiceManagement,
    requiresLayout: true,
    requiredPermissions: ['service.read'],
    requiredRoles: ['admin', 'manager'],
  },
];
